"use strict";

/**
* Dynamically sets the background image for the checkout progress bar steps based on a data attribute.
* Retrieves the image URL from the 'data-progress-image' attribute of the element with class 'progress-steps'.
* If the URL exists, injects a <style> tag into the document head to update the background image of each step.
*/
function checkoutProgressBar() {
    var imageUrl = $(".progress-steps").attr("data-progress-image");
    if (imageUrl) {
        var style = document.createElement("style");
        style.innerHTML = `
            .checkout-progress-bar .progress-steps .step::before {
                background-image: url('${imageUrl}');
            }
        `;
        document.head.appendChild(style);
    }
}

export default checkoutProgressBar;
